import { createSlice, createAction } from "@reduxjs/toolkit";
import { RootState } from "store/store";
import { FormRequest, FormRequestQueryParams } from "../type";

interface FormRequestState {
	formRequestList: Array<FormRequest>;
	formRequestTotal: number;
}

export const formRequestDefault: FormRequest = {
	_id: "",
	name: "",
	description: "",
	phoneNumber: "",
	email: "",
	refId: null,
};

const initialState: FormRequestState = {
	formRequestList: [],
	formRequestTotal: 0,
};

export const formRequestSlice = createSlice({
	name: "formRequest",
	initialState,
	reducers: {
		setListFormRequest: (state, action) => {
			state.formRequestList = action.payload.data;
			state.formRequestTotal = action.payload.total;
		},
	},
});

export const selectFormRequestList = (state: RootState) =>
	state.formRequest.formRequestList;
export const selectFormRequestTotal = (state: RootState) =>
	state.formRequest.formRequestTotal;

export const { setListFormRequest } = formRequestSlice.actions;

export interface GetListFormRequestAsyncPayload {
	query: FormRequestQueryParams;
	callback?: () => void;
}

export const getListFormRequestAsync = createAction(
	"formRequest/getListFormRequestAsync",
	(payload: GetListFormRequestAsyncPayload) => ({
		payload: payload || {},
	}),
);

export default formRequestSlice.reducer;
